import { triggeradfPipeline } from "./triggeradfApi";

export interface PipelineParams {
  selectedDC: string;
  selectedTGTEnv: string;
  selectedTGTEnvReg: string;
  userId: string;
  interfaceName: string;
  onClear: () => void;
  setStatus: (status: string | null) => void;
  setPublishing: (publishing: boolean) => void;
}

export const handleRunPipeline = async ({
  selectedDC,
  selectedTGTEnv,
  selectedTGTEnvReg,
  userId,
  interfaceName,
  onClear,
  setStatus,
  setPublishing,
}: PipelineParams): Promise<void> => {
  setPublishing(true);
  try {
    const result = await triggeradfPipeline(
      selectedDC,
      selectedTGTEnv,
      selectedTGTEnvReg,
      userId,
      interfaceName
    );
    onClear();
    if (result?.runId) {
      setStatus(
      `Data load Process Initiated. Please wait a few minute and check on the ${interfaceName} history Tab for the load status`
    );
    } else {
      setStatus("Pipeline trigger response was missing a Run ID. Please check with Support team.");
    }
    
  } catch (error: any) {
    console.error("Failed to run pipeline", error);
    onClear();
    if (error?.code === "ECONNABORTED") {
      setStatus("Request timed out. Please try again later.");
    } else if (error?.response?.status === 504) {
      setStatus("Server took too long to respond. Pipeline may still be running.");
    } else if (error?.response?.status === 409) {
      setStatus(`${error.response.data?.message}`);
    } else if (error?.response) {
      setStatus(
        `Error: ${error.response.status} - ${JSON.stringify(
          error.response.data
        )}`
      );
    } else if (error?.request) {
      setStatus("No response from backend. Check if the server is running.");
    } else {
      setStatus(`Request setup error: ${error.message}`);
    }
  } finally {
    setPublishing(false);
  }
};
